import { useEffect } from 'react';

/**
 * v1.5.9 STABILITY FIX:
 * The @capacitor/push-notifications plugin was temporarily removed because it
 * requires a valid google-services.json Firebase config to boot. Without it,
 * the Android app crashes at launch (Firebase init throws in the native layer).
 *
 * Once Firebase project is set up and google-services.json is dropped into
 * /app/frontend/android/app/, re-add the plugin:
 *   yarn add @capacitor/push-notifications
 * and restore the original registration logic (see git history for reference).
 *
 * For now this hook is a safe no-op so the shell code can keep calling it.
 */
export function usePushNotifications() {
    useEffect(() => {
        // Intentional no-op — see file header.
    }, []);
}

export default usePushNotifications;
